import { companyPropertiesConstants } from '../../../constants/appConstants';
import { companyPropertiesQuery } from '../../../queries/companyQuery';
import { teamsQuery } from '../../../queries/teamQuery';
import { userQuery } from '../../../queries/userQuery';

import type { QueryClient } from '@tanstack/react-query';

export const settingsTeamsLoader = async ({ queryClient }: { queryClient: QueryClient }) => {
	const user = await queryClient.ensureQueryData(userQuery);

	const teams = await queryClient.ensureQueryData(teamsQuery({ offset: 0, limit: 10 }));

	const companyProperties = await queryClient.ensureQueryData(
		companyPropertiesQuery(user.companyAccountId, companyPropertiesConstants),
	);

	return {
		user,
		teams,
		companyProperties,
	};
};
